import { toString, Union } from "../fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { singleton, map, tail, head, isEmpty, ofArray } from "../fable_modules/fable-library.3.7.20/List.js";
import { error } from "../Components/Message/Message.js";
import * as react from "react";
import { render } from "./TestData.js";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { formatUrl } from "../Utils.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Default", "TestData", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("DevTools.Base.Page", [], Page, () => [[], [], []]);
}

export const linkablePages = ofArray([new Page(0), new Page(1)]);

export function parseUrl(_arg) {
    let pattern_matching_result;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "Default") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else if (head(_arg) === "TestData") {
            if (isEmpty(tail(_arg))) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Page(0);
        }
        case 1: {
            return new Page(1);
        }
        case 2: {
            return new Page(2);
        }
    }
}

function view(page, isAdminUser) {
    let children_10;
    if (!isAdminUser) {
        const children = [error("You do not have the neccessary permissions to view this page.".split(""))];
        return react.createElement("div", {
            className: "p-2",
        }, ...children);
    }
    else {
        const subPageHtml = (page.tag === 1) ? render : ((page.tag === 2) ? react.createElement("div", {}, "Not found") : react.createElement("div", {}, "Default page"));
        const children_12 = [react.createElement("h2", {}, "DevTools"), (children_10 = map((page_1) => {
            const url = RouterModule_encodeParts(formatUrl(RouterModule_urlSegments(window.location.hash, 1), singleton("DevTools"), singleton(toString(page_1))), 1);
            const children_2 = [toString(page_1)];
            return react.createElement("a", {
                href: url,
                className: "mr-2",
            }, ...children_2);
        }, linkablePages), react.createElement("ol", {
            className: "p-0",
        }, ...children_10)), subPageHtml];
        return react.createElement("div", {
            className: "p-2",
        }, ...children_12);
    }
}

export function lazyView(props) {
    return view(props.Page, props.IsAdminUser);
}

